import React, { createContext, useReducer, useCallback } from "react";
import { BannerContextType, BannerState, ProviderProps } from "../types";

// Initial state
const initialState: BannerState = {
  isOpen: false,
  message: undefined,
};

// Create context
export const BannerContext = createContext<BannerContextType>({
  ...initialState,
  openBanner: () => {},
  closeBanner: () => {},
});

// Banner reducer
const bannerReducer = (state: BannerState, action: any): BannerState => {
  switch (action.type) {
    case "OPEN_BANNER":
      return {
        ...state,
        isOpen: true,
        message: action.message,
      };
    case "CLOSE_BANNER":
      return {
        ...state,
        isOpen: false,
        message: undefined,
      };
    default:
      return state;
  }
};

// Provider component
export const BannerProvider: React.FC<ProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(bannerReducer, initialState);

  // Open banner action
  const openBanner = useCallback((message: string) => {
    dispatch({
      type: "OPEN_BANNER",
      message,
    });
  }, []);

  // Close banner action
  const closeBanner = useCallback(() => {
    dispatch({ type: "CLOSE_BANNER" });
  }, []);

  return (
    <BannerContext.Provider
      value={{
        ...state,
        openBanner,
        closeBanner,
      }}
    >
      {children}
    </BannerContext.Provider>
  );
};
